import { Component } from '@angular/core';
import { FormGroup, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { EmailService } from 'src/app/shared/services/email.service';

@Component({
  selector: 'app-brand-development',
  templateUrl: './brand-development.component.html',
  styleUrls: ['./brand-development.component.scss'],

})
export class BrandDevelopmentComponent {
  brandDevelopmentForm: UntypedFormGroup;
  showSuccess: boolean = false;
  marketSegment: string[] = [
    "Full Service",
    "Boutique",
    "Midscale",
    "Economy",
    "Extended Stay"
  ];
  states: string[] = ['Outside US','Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
 
  constructor(fb: UntypedFormBuilder, private emailService: EmailService) {
    this.brandDevelopmentForm = fb.group({
      contactInformation: new FormGroup({
        firstName: new UntypedFormControl(null, [Validators.required, Validators.minLength(3)]),
        lastName: new UntypedFormControl(null, [Validators.required, Validators.minLength(2)]),
        // The regex /^[0-9-]{10,15}$/ validates that:
        // ^ - start of string
        // [0-9-] - only digits 0-9 and hyphens allowed
        // {7,15} - between 7 and 15 characters long
        // $ - end of string
        // So this ensures a phone number between 10-15 digits, optionally with hyphens
        phone: new UntypedFormControl(null, [Validators.required, Validators.pattern(/^[0-9-]{7,15}$/)]),
        email: new UntypedFormControl(null, [Validators.required, Validators.email]),
      }),
      city: new UntypedFormControl(null, Validators.required),
      state: new UntypedFormControl(null, Validators.required),
      roomCount: new UntypedFormControl(10, [Validators.required, Validators.min(10)]),
      propertyName: new UntypedFormControl(null, Validators.required),
      propertyType: new UntypedFormControl(null, Validators.required),
      affiliationType: new UntypedFormControl(null, Validators.required),
      marketSegment: new UntypedFormControl(null, Validators.required),
      callSchedule: new FormGroup({
        date: new UntypedFormControl(null, Validators.required),
        time: new UntypedFormControl("00:00", Validators.required)
      }),
      acceptTerms: new UntypedFormControl(false, Validators.requiredTrue),
    });
  }

  onSubmit() {
    let formData = {
      name: this.brandDevelopmentForm.value.contactInformation.firstName + ' ' + this.brandDevelopmentForm.value.contactInformation.lastName,
      phone: this.brandDevelopmentForm.value.contactInformation.phone,
      email: this.brandDevelopmentForm.value.contactInformation.email,
      city: this.brandDevelopmentForm.value.city,
      state: this.brandDevelopmentForm.value.state,
      roomCount: this.brandDevelopmentForm.value.roomCount,
      propertyName: this.brandDevelopmentForm.value.propertyName,
      propertyType: this.brandDevelopmentForm.value.propertyType,
      affiliationType: this.brandDevelopmentForm.value.affiliationType,
      marketSegment: this.brandDevelopmentForm.value.marketSegment,
      date: this.brandDevelopmentForm.value. callSchedule.date,
      time: this.brandDevelopmentForm.value. callSchedule.time,
      acceptTerms: this.brandDevelopmentForm.value.acceptTerms
    };

    const body = {
      "bodyJson": formData,
      "html": true,
      "json": "true",
      "beautifyJson": true,
      "subject": "Development Inquiry",
      "to": ["info@fairbridgeinns.com"],
      "body": ""
    };

    this.emailService.sendEmail(body, 'info-fairbridgeinns').subscribe(data => {
      this.showSuccess = true;
      this.brandDevelopmentForm.reset();
    });
  }

  get contactInfo() {
    return this.brandDevelopmentForm.get('contactInformation') as FormGroup;
  }

  get contactSchedule() {
    return this.brandDevelopmentForm.get('callSchedule') as FormGroup;
  }

  clearForm() {
    this.brandDevelopmentForm.reset();
  }
}
